import React from 'react';
import { 
  Modal, 
  Box, 
  Typography, 
  IconButton, 
  Paper,
  Button
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import { getDownloadUrl } from '../services/api';

const PreviewModal = ({ 
  open, 
  onClose, 
  filename, 
  content 
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="preview-modal-title"
    >
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: { xs: '90%', sm: '80%', md: '70%' },
        maxHeight: '80vh',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 3,
        borderRadius: 1,
        display: 'flex',
        flexDirection: 'column'
      }}>
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2
        }}>
          <Typography id="preview-modal-title" variant="h6" component="h2">
            Vista Previa: {filename}
          </Typography>
          
          <Box>
            <Button
              variant="outlined"
              size="small"
              startIcon={<DownloadIcon />}
              href={getDownloadUrl(filename)}
              download
              sx={{ mr: 1 }}
            >
              Descargar
            </Button>
            
            <IconButton 
              onClick={onClose}
              color="inherit"
              size="small"
              aria-label="cerrar"
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
        
        <Paper
          elevation={1}
          sx={{
            p: 2,
            flex: 1,
            overflow: 'auto',
            maxHeight: 'calc(80vh - 100px)',
            bgcolor: '#f5f5f5'
          }}
        >
          <pre style={{ 
            whiteSpace: 'pre-wrap', 
            margin: 0, 
            fontFamily: 'monospace' 
          }}>
            {content || 'No hay contenido para mostrar.'}
          </pre>
        </Paper>
      </Box>
    </Modal>
  );
};

export default PreviewModal; 